import React from 'react';
import './Jalousie.css';

const Jalousie = (props) => {
    return (
        <div>
            <img src={props.rightSrc} className='rightJalousie' alt=' ' />
            <img src={props.leftSrc} className='leftJalousie' alt=' ' />
 
        </div>
    );
};
export default Jalousie;